// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMoveHorizontal as RawLucideMoveHorizontal } from "lucide-react";
export const LucideMoveHorizontal = /* @__PURE__ */ createIcon(RawLucideMoveHorizontal, "LucideMoveHorizontal", 2);
